import { useTranslation } from "next-i18next";
import { getGlobals } from "src/consts/globals";
import { useDateTimeFormatter } from "src/hooks/formatters/use-date-time-formatter";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";
import { useCertificateBoxContext } from "../context";
import { IndicatorShell } from "./indicator-shell/indicator-shell";

const CERTIFICATE_BOX_STATISTIC_TEST_ID = "certificate-box-statistic";

export const CBEmission = () => {
    const { dict, data, selectedCertificate: certificate } = useCertificateBoxContext();
    const { formatDateShort } = useDateTimeFormatter();

    return (
        <IndicatorShell
            dataTestId={CERTIFICATE_BOX_STATISTIC_TEST_ID}
            tooltip={data.tooltips.emissionDate!}
            indicatorName={dict.emissionDate}
            indicatorValue={formatDateShort(new Date(certificate.emissionDate))}
        />
    );
};

export const CBCertificateFee = () => {
    const { dict, data } = useCertificateBoxContext();
    const { formatPercent } = useNumberFormatter();

    return (
        <IndicatorShell
            dataTestId={CERTIFICATE_BOX_STATISTIC_TEST_ID}
            tooltip={data.tooltips.certificateFeePerYear}
            indicatorName={dict.base!.certificateFeePerYear}
            indicatorValue={formatPercent(data.wikifolio.dailyFee, 2)}
        />
    );
};

export const CBPerformanceFee = () => {
    const { dict, data } = useCertificateBoxContext();
    const { formatPercent } = useNumberFormatter();

    return (
        <IndicatorShell
            dataTestId={CERTIFICATE_BOX_STATISTIC_TEST_ID}
            tooltip={data.tooltips.performanceFee}
            indicatorName={dict.base!.performanceFee}
            indicatorValue={formatPercent(data.wikifolio.performanceFee, 2)}
        />
    );
};

export const CBLiquidationFigure = () => {
    const { data } = useCertificateBoxContext();
    const { t } = useTranslation("wf-detail");
    const { formatNumber } = useNumberFormatter();

    let liquidationFigure = "-";
    if (data.keyFigures.liquidationFigure.ranking.value) {
        liquidationFigure = formatNumber(data.keyFigures.liquidationFigure.ranking.value, 1) + " " + t("days");
    }

    return (
        <IndicatorShell
            dataTestId={CERTIFICATE_BOX_STATISTIC_TEST_ID}
            tooltip={data.keyFigures.liquidationFigure.tooltip!}
            indicatorName={data.keyFigures.liquidationFigure.ranking.label}
            indicatorValue={liquidationFigure}
        />
    );
};

export const CBTradingVolume = () => {
    const { data } = useCertificateBoxContext();
    const { formatNumber } = useNumberFormatter();

    let tradingVolume = "-";
    if (data.keyFigures.tradingVolume.ranking.value) {
        tradingVolume = `${getGlobals().currency} ${formatNumber(data.keyFigures.tradingVolume.ranking.value)}`;
    }

    return (
        <IndicatorShell
            dataTestId={CERTIFICATE_BOX_STATISTIC_TEST_ID}
            tooltip={data.keyFigures.tradingVolume.tooltip!}
            indicatorName={data.keyFigures.tradingVolume.ranking.label}
            indicatorValue={tradingVolume}
        />
    );
};

export const CBExchangeRatio = () => {
    const { dict, data, selectedCertificate: certificate } = useCertificateBoxContext();
    const { formatNumber } = useNumberFormatter();

    const ratio = `1 : ${formatNumber(certificate.exchangeRatioMultiplier)}`;

    return (
        <IndicatorShell
            dataTestId={CERTIFICATE_BOX_STATISTIC_TEST_ID}
            tooltip={data.tooltips.exchangeRatio}
            indicatorName={dict.base!.exchangeRatio}
            indicatorValue={ratio}
        />
    );
};
